var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.fileModalOpen,
        "body-class": "p-0",
        "modal-class": "asset-modal",
        "ok-title": "confirm",
        size: "xl",
        title: "Asset Manager"
      },
      on: {
        ok: _vm.commitAsset,
        cancel: _vm.closeAssetModal,
        hide: _vm.closeAssetModal
      }
    },
    [
      _vm.initialized
        ? _c("p", [_vm._v("Loading...")])
        : _c(
            "div",
            [
              _vm.fileModalOpen
                ? _c("file-manager-component", {
                    attrs: {
                      content: _vm.content,
                      timestamp: _vm.timestamp,
                      currentValue: _vm.currentAsset,
                      getData: _vm.getData,
                      replaceData: _vm.replaceData,
                      createData: _vm.modifiedCreateData,
                      updateBatch: _vm.modifiedUpdateBatch,
                      addNotification: _vm.addNotification,
                      allowedExtensions: _vm.config.extensions,
                      multiple: _vm.config.multiple,
                      storagePanel: _vm.config.storagePanel,
                      storages: _vm.config.storages,
                      embedded: true,
                      hide: !_vm.fileModalOpen
                    },
                    on: {
                      "fm::asset::select": _vm.selectAsset,
                      "fm::asset::dblclick": _vm.pickSelectAsset
                    }
                  })
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85910c7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85910c7c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/GlobalFileModalComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-85910c7c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/GlobalFileModalComponent.vue
// module chunks = 0